import React from  'react';
import CarouselContainerAurum from '../CarouselContainerAurum.js';

function TimelineExplainerAu() {
    return (
        <div className="Timeline">
            <CarouselContainerAurum/>
        </div>
    );
}

export default TimelineExplainerAu;


